import { render, staticRenderFns } from "./TypingStatus.vue?vue&type=template&id=0ed8c3ec&scoped=true&lang=pug"
import script from "./TypingStatus.vue?vue&type=script&lang=js"
export * from "./TypingStatus.vue?vue&type=script&lang=js"
import style0 from "./TypingStatus.vue?vue&type=style&index=0&id=0ed8c3ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8c3ec",
  null
  
)

export default component.exports